import { useContext, useState } from 'react';

import WorkTemplateCreationModal from '@atom/components/common/workTemplateCreationModal/WorkTemplateCreationModal';
import WorkTemplatesContext from '@atom/components/workTemplates/WorkTemplatesContext';
import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import { AddIcon, ArrowBackIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import classes from './workTemplates.module.css';

const WorkTemplatesHeader = () => {
  const [, { navigate }] = useNavigation();
  const { setActiveFolderId } = useContext(WorkTemplatesContext);
  const [open, setOpen] = useState<boolean>(false);

  const navigateBack = (): void => {
    navigate('/workOrders');
  };

  const handleClose = () => {
    setOpen(false);
    setActiveFolderId('workTypes');
  };

  const showCreate = hasRolePermissions(ROLE_SETS.ORG_ADMIN);

  return (
    <>
      <div className={classes.headerContainer}>
        <div>
          <IconButton onClick={navigateBack}>
            <Icon color={colors.neutral.white} icon={ArrowBackIcon} />
          </IconButton>
          <div className={classes.breadcrumbNameContainer}>
            <span>Work Templates</span>
          </div>
        </div>
        {showCreate && (
          <IconButton
            onClick={() => setOpen(true)}
            disabled={!showCreate}
            data-cy="addTemplateButton"
          >
            <Icon color={colors.neutral.white} icon={AddIcon} />
          </IconButton>
        )}
      </div>
      <WorkTemplateCreationModal open={open} closeModal={handleClose} />
    </>
  );
};

export default WorkTemplatesHeader;
